/** §3.1 Identity. Branded IDs make an accidental object assignment a compile error (I7). */

export type Brand<T, B extends string> = T & { readonly __brand: B };

export type PlayerId = Brand<string, "PlayerId">;
export type HeroId = Brand<string, "HeroId">;
export type TownId = Brand<string, "TownId">;
export type ArmyId = Brand<string, "ArmyId">;
export type StackId = Brand<string, "StackId">;
export type ObjectId = Brand<string, "ObjectId">;
export type InteractionId = Brand<string, "InteractionId">;
/** A column of creatures walking from where they were bought to a town. */
export type CaravanId = Brand<string, "CaravanId">;

export type CreatureDefId = Brand<string, "CreatureDefId">;
export type SpellDefId = Brand<string, "SpellDefId">;
export type ArtifactDefId = Brand<string, "ArtifactDefId">;
export type SkillDefId = Brand<string, "SkillDefId">;
/** One branch of a secondary skill - see `SubskillDef`. */
export type SubskillDefId = Brand<string, "SubskillDefId">;
export type BuildingDefId = Brand<string, "BuildingDefId">;
export type HeroDefId = Brand<string, "HeroDefId">;
export type FactionId = Brand<string, "FactionId">;
export type ModifierSrcId = Brand<string, "ModifierSrcId">;

/** Coordinates are typed apart from screen space (I14). */
export type AdventureCoord = Brand<number, "AdventureCoord">;
export type HexCoord = Brand<number, "HexCoord">;
export type PixelCoord = Brand<number, "PixelCoord">;

export type IdKind =
  | "hero" | "army" | "town" | "object" | "stack" | "interaction" | "caravan";

export const asPlayerId = (s: string): PlayerId => s as PlayerId;
export const asHeroId = (s: string): HeroId => s as HeroId;
export const asTownId = (s: string): TownId => s as TownId;
export const asArmyId = (s: string): ArmyId => s as ArmyId;
export const asObjectId = (s: string): ObjectId => s as ObjectId;
export const asCaravanId = (s: string): CaravanId => s as CaravanId;
export const asStackId = (s: string): StackId => s as StackId;
export const asCreatureDefId = (s: string): CreatureDefId => s as CreatureDefId;
export const asSpellDefId = (s: string): SpellDefId => s as SpellDefId;
export const asArtifactDefId = (s: string): ArtifactDefId => s as ArtifactDefId;
export const asFactionId = (s: string): FactionId => s as FactionId;
export const asModifierSrcId = (s: string): ModifierSrcId => s as ModifierSrcId;
